/*
  QUICK-ADD CART BUTTON — the small cart-icon button on collection/search
  cards, sitting beside "Shop Now".

  FOUND 9 Aug 2026: this button has never worked. ctx-card-product.liquid
  renders it as a bare <button data-variant-id="..."> with no <form> around
  it — that markup is only correct if something is listening for its click.
  Nothing was. Confirmed two ways: no file in this theme's assets referenced
  ".bsfg-btn-cart" or "data-variant-id" as a click target, and clicking the
  real button on the live Best Sellers grid fired zero requests — no
  /cart/add.js, nothing. Every multi-variant product on every collection and
  search grid has been carrying a button that quietly does nothing since
  quick_add:'standard' still routes multi-variant cards through this bare
  branch (see ctx-card-product.liquid: the <product-form> branch only fires
  when variants_count == 1).

  Single-variant cards were never affected — they render a real <product-form>
  with a submit button, which product-form.js already handles correctly.

  This wires the bare button up to the SAME mechanism product-form.js uses,
  so it behaves identically: fetch → cart.renderContents() to update the
  drawer/notification and the header bubble → publish cartUpdate for anything
  else listening. Deliberately not a parallel implementation — reusing the
  theme's own working path means this can never drift from how "real"
  add-to-cart behaves.
*/
(function () {
  'use strict';

  function getCart() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.bsfg-btn-cart[data-variant-id]');
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    var cart = getCart();

    /*
      No drawer or notification on this page (cart_type set to a plain page,
      or the element simply is not present here) — product-form.js's own
      fallback in this situation is to send the shopper to the cart page
      instead of trying to render sections that do not exist. Matched here
      for the same reason: a silent failure is worse than an extra page load.
    */
    if (!cart) {
      window.location = (window.routes && window.routes.cart_url) || '/cart';
      return;
    }

    /* No separate loading class — [disabled]/[aria-disabled] already dim the
       button (see ctx-card-product.liquid's own CSS), which is enough of a
       "something is happening" cue for a request this fast. */
    btn.disabled = true;
    btn.setAttribute('aria-disabled', 'true');

    var config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
    formData.append('sections_url', window.location.pathname);
    if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    config.body = formData;

    fetch(window.routes.cart_add_url, config)
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) {
          /* Sold out between page load and click, or a genuine rejection.
             publish() so anything listening for cart errors elsewhere on the
             page (the same event product-form.js fires) hears about it too. */
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'ctx-quick-add',
              productVariantId: variantId,
              errors: response.errors || response.description,
              message: response.message
            });
          }
          btn.classList.add('bsfg-btn-cart--error');
          setTimeout(function () { btn.classList.remove('bsfg-btn-cart--error'); }, 2000);
          return;
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'ctx-quick-add',
            productVariantId: variantId,
            cartData: response
          });
        }

        cart.renderContents(response);
        if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');

        /* .bsfg-btn-cart--added already existed in the stylesheet with nothing
           ever turning it on — the author clearly meant for a JS click handler
           to use it. */
        btn.classList.add('bsfg-btn-cart--added');
        setTimeout(function () { btn.classList.remove('bsfg-btn-cart--added'); }, 1500);
      })
      .catch(function (err) {
        console.error(err);
        btn.classList.add('bsfg-btn-cart--error');
        setTimeout(function () { btn.classList.remove('bsfg-btn-cart--error'); }, 2000);
      })
      .finally(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');
      });
  });
})();
